import { HorizontalContainer } from '@american-autonomy/ag-ui';

import DropdownMenuItemContainer from 'components/DropdownMenuItemContainer';
import JohnDeereIcon from 'components/icons/JohnDeereIcon';
import DropdownText from 'components/text/DropdownText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DetailsViewCardHeaderDropdownMenuItem: FunctionComponent<Props> = ({
    className = '',
    hasJohnDeereIcon = false,
    isDisabled = false,
    onClick,
    testId = TEST_ID,
    text
}) => (
    <DropdownMenuItemContainer
        className={`${className} ${styles.dropdownMenuItemContainer}`}
        isDisabled={isDisabled}
        onClick={onClick}
        testId={testId}>
        {hasJohnDeereIcon ? (
            <HorizontalContainer className={styles.iconLabel}>
                <JohnDeereIcon />

                <DropdownText text={text} />
            </HorizontalContainer>
        ) : (
            <DropdownText text={text} />
        )}
    </DropdownMenuItemContainer>
);

export default DetailsViewCardHeaderDropdownMenuItem;
